'use client';

import { Button } from '@mokoboko/components';

import { EmptyCalendarState } from '@/components/empty-calendar-state';
import { useRetryReads } from '@/hooks/use-retry-reads';

// A button rather than "refresh": a page opened from the Home Screen has no
// reload control of its own.
export const ClassesLoadError = ({
  title = "Couldn't load classes",
}: {
  title?: string;
}) => {
  const { retry, isRetrying } = useRetryReads();

  return (
    <EmptyCalendarState
      className="py-6"
      title={title}
      description="Something went wrong on our end. Please try again."
      primaryAction={
        <Button
          variant="secondary-gray"
          isProcessing={isRetrying}
          onClick={retry}
        >
          Try again
        </Button>
      }
    />
  );
};
